module.exports = __webpack_public_path__ + "static/media/delete-icon.f674d0c9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/delete-icon.svg
// module id = 255
// module chunks = 0